import axios from 'axios'
import { Dispatch, SetStateAction } from 'react';
import 'regenerator-runtime/runtime'
import { IClient, IUser } from '.';

class Postier {
    affectUserApp(token: string, data, setErrors: Dispatch<SetStateAction<string[]>>) {
        axios.post(`api-v0/accessdb`,data,{headers:{ Authorization: `Bearer ${token}` }})
        .then(res=>{
            if (res.data) {
                setErrors((errors: string[]) => [...errors, "Le user a bien été affecté, il sera pris en compte dans 10 minutes"])
                // location.reload();
            }
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Le user ne peut pas être affecté"])
            localStorage.clear()
            // location.reload()
        }) 
    }

    getUserList(token: string, application: string, setUserList: Dispatch<SetStateAction<IUser[]>>) {
        axios.get(`api-v0/users`, { params: { application }, headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
            setUserList(res.data)
        }).catch(() => {
            setUserList([])
        }) 
    }

    getClientList(token: string, setClients: Dispatch<SetStateAction<IClient[]>>, userid: number, setErrors: Dispatch<SetStateAction<string[]>>){
        axios.get(`api-v0/allclients`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setClients(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "La liste des clients ne peut pas être récupéré"])
            localStorage.clear()
            // location.reload()
        })

    }

    getUrlList(token: string, setUrls, setErrors: Dispatch<SetStateAction<string[]>>){
        axios.get(`data/urls`,{headers:{ Authorization: `Bearer ${token}` }}).then(res=>{
            setUrls(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "La liste des urls ne peut pas être récupéré"])
            localStorage.clear()
            // location.reload()
        })
    }


}

export const UserAppPostier = new Postier()